<template>
  <b-container v-if="customerInfo">
    <div id="avatar">
      <b-avatar variant="light" :src="avatarUrl" size="11.4375rem"></b-avatar>
      <h2 style="weight: bold;">{{ customerInfo.user.firstName }}</h2>
      <p>
        <span v-if="customerInfo.user.paid == false">Free </span>
        <span v-else-if="customerInfo.user.paid == true">Premium </span>
        <span v-else>Free </span>
        user
      </p>
    </div>
    <div>
      <b-nav class="side-menu" vertical>
        <b-nav-item class="profile" href="#" v-if="false"
          ><span><ProfileIcon /></span> Profile</b-nav-item
        >
        <b-nav-item class="language" href="#" v-if="false"
          ><span><LanguageIcon /></span> Language</b-nav-item
        >
        <b-nav-item class="security" href="#" v-if="false"
          ><span><SecurityIcon /></span> Security</b-nav-item
        >
        <b-nav-item class="details" href="#" v-if="false"
          ><span><BillingDetailsIcon /></span> Billing Details</b-nav-item
        >
        <!-- Premium Material -->
        <b-nav-item
          v-if="false"
          class="premium"
          href="#"
          @click="goToPremiumPage()"
          :disabled="!customerInfo.user.paid"
          ><span><PremiumMaterialIcon /></span> Premium Material</b-nav-item
        >
        <!-- Premium Material -->

        <b-nav-item class="history" v-on:click="$emit('navigate', 'Invoices')"
          ><span><BillingHistoryIcon /></span> Invoices</b-nav-item
        >
        <b-nav-item class="history" v-on:click="$emit('navigate', 'Billing')"
          ><span><BillingHistoryIcon /></span> Billing Details</b-nav-item
        >
        <b-nav-item
          class="manager"
          v-on:click="$emit('navigate', 'Subscriptions')"
          ><span><ManagerSubscriptionsIcon /></span> Subscriptions</b-nav-item
        >
        <div class="divider"></div>
        <b-nav-item class="back" href="https://app.dropsmart.io"
          ><span><DropsmartDropIcon /></span>Back to Dropsmart</b-nav-item
        >
        <b-nav-item class="logout" href="#" @click="logoff()"
          ><span><LogoutIcon /></span> Logout</b-nav-item
        >
      </b-nav>
      <p class="side-logo text-center">
        <img
          src="../../../assets/images/logo-dropsmart-sidebar.png"
          alt="Logo"
          class=""
        />
      </p>
    </div>
  </b-container>
</template>

<script>
import ProfileIcon from "../../icons/ProfileIcon.vue";
import LanguageIcon from "../../icons/LanguageIcon.vue";
import SecurityIcon from "../../icons/SecurityIcon.vue";
import PremiumMaterialIcon from "../../icons/PremiumMaterialIcon.vue";
import BillingDetailsIcon from "../../icons/BillingDetailsIcon.vue";
import BillingHistoryIcon from "../../icons/BillingHistoryIcon.vue";
import ManagerSubscriptionsIcon from "../../icons/ManagerSubscriptionsIcon.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import DropsmartDropIcon from "../../icons/DropsmartDropIcon.vue";
import { FRONTEND_URL } from "../../../config";

export default {
  name: "MenuLeft",
  props: ["customerInfo"],
  components: {
    ProfileIcon,
    LanguageIcon,
    SecurityIcon,
    PremiumMaterialIcon,
    BillingDetailsIcon,
    BillingHistoryIcon,
    ManagerSubscriptionsIcon,
    LogoutIcon,
    DropsmartDropIcon,
  },
  computed: {
    avatarUrl() {
      if (!this.customerInfo || !this.customerInfo.user.avatarUrl) {
        return null;
      }
      return FRONTEND_URL.AvatarURL + this.customerInfo.user.avatarImage;
    },
  },
  methods: {
    logoff: function() {
      sessionStorage.setItem("customerInfo", null);
      this.$router.push("/login");
    },
    goToPremiumPage: function() {
      console.log("LEFT MENU - PAID attribute: " + JSON.parse(this.customerInfo).user.paid);
      if (this.customerInfo.user.paid == true) {
        this.$router.push("/private/my-premium-material");
      }
    },
  },
};
</script>
<style lang="scss">
$color: #000000;

#avatar {
  padding-top: 65px;
  text-align: center;
  .b-avatar {
    margin-bottom: 35px;
  }
  h2 {
    color: #000000;
    font-size: 36px;
    font-weight: 700;
    margin: 0;
  }
  p {
    color: #4d4d4d;
    font-size: 16px;
  }
}

.side-logo {
  padding-top: 250px;
}

.side-menu {
  font-size: 18px;
  margin: 0 auto;
  margin-top: 60px;
  max-width: 220px;
  .divider {
    background-color: #d7d7d7;
    height: 1px;
    width: 100%;
    max-width: 135px;
    display: block;
    margin: 20px auto;
  }
  .nav-item {
    &.language svg {
      width: 18px;
    }
    &.details svg {
      width: 22px;
    }
    &.premium svg {
      width: 23px;
    }
    &.history svg {
      width: 15px;
    }
    &.manager svg {
      width: 23px;
    }
    &.back svg {
      width: 16px;
    }
    &.logout {
      svg {
        width: 19px;
      }
      span {
        text-align: left;
      }
    }
  }
  .nav-link {
    color: #999999;
    display: flex;
    align-items: center;
    padding: 0;
    line-height: 50px;
    span {
      margin-right: 20px;
      width: 24px;
      text-align: center;
    }
    svg {
      fill: #999999;
      width: 14px;
    }
    &:hover {
      color: #ee4586;
      svg {
        fill: #ee4586;
      }
    }
    &.active {
      color: #ee4586;
      svg {
        fill: #ee4586;
      }
    }
  }
}

@media screen and (max-width: 854px) {
  .side-logo {
    padding-top: 50px;
  }
}
</style>
